import './schedule.css';
import { useTranslation } from 'react-i18next';
import ReactGA from 'react-ga4';

type ScheduleSectionProps = {
  variant?: 'default' | 'hero';
};

const ScheduleSection = ({ variant = 'default' }: ScheduleSectionProps) => {
  const { t } = useTranslation();

  function onCallClick(): void {
    ReactGA.send({ hitType: 'event', eventCategory: 'Schedule', eventAction: 'Schedule Click', eventLabel: t('schedule') });
    window.open('https://calendly.com/cloudsibyl/demo', '_blank');
  }

  return (
    <button
      className={`call-button${variant === 'hero' ? ' call-button--hero' : ''}`}
      onClick={onCallClick}
    >
      {t('schedule')}
      {variant === 'hero' ? (
        <svg
          aria-hidden="true"
          viewBox="0 0 16 16"
          className="call-button-arrow"
        >
          <path
            d="M3 8h9m-3.5-4L12 8l-3.5 4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : null}
    </button>
  );
};

export default ScheduleSection;
